module.exports = __webpack_public_path__ + "img/features-split-image-01.340d8195.jpg";